/**
 *
 * @desc: 公共配置
 *
 */

// 缓存版本
export const CACHE_VERSION = 20220620
